import React, { useCallback } from "react";
import axios from 'axios';
import { useDropzone } from "react-dropzone";
import Authentication from "../../../api/Authentication/Authentication";
import API from "../../../api/API";

const FileUploadZone = ({ currentDirectory, onUploadComplete, setDownloads }) => {

  const onDrop = useCallback(
    (acceptedFiles) => {
      acceptedFiles.forEach((file) => {
        // Create a cancel token for this file upload
        const cancelTokenSource = axios.CancelToken.source();

        // Create a new transfer entry for the upload with a unique id and type "upload"
        const newTransfer = { 
          id: Date.now(), 
          name: file.name, 
          progress: 0, 
          size: file.size, 
          completed: false, 
          type: "upload",
          cancelTokenSource, 
        };
        setDownloads((prev) => [...prev, newTransfer]);

        API.uploadFile(            
            Authentication.getCurrentUser()?._id, 
            Authentication.getCurrentUser()?.token, 
            currentDirectory.id, 
            file.name,
            file, 
            {
              cancelToken: cancelTokenSource.token,
              onUploadProgress: (progressEvent) => {
                // Update the progress of the current upload
                setDownloads((prev) =>
                  prev.map((transfer) =>
                    transfer.id === newTransfer.id
                      ? { ...transfer, progress: (progressEvent.loaded / file.size) * 100 }
                      : transfer
                  )
                );
              },
            })
          .then((result) => {
            if (onUploadComplete) onUploadComplete(newTransfer);
          })
          .catch((error) => {
            if (axios.isCancel(error)) {
              console.log(`Upload canceled for ${file.name}`);
              // Optionally, remove the transfer or mark it as failed
              setDownloads((prev) =>
                prev.map((transfer) =>
                  transfer.id === newTransfer.id
                    ? { ...transfer, progress: 100, aborted: true,  }
                    : transfer
                )
              );
            } else {
              console.error(`Upload error for ${file.name}:`, error);
              // Optionally, remove the transfer or mark it as failed
              setDownloads((prev) =>
                prev.map((transfer) =>
                  transfer.id === newTransfer.id
                    ? { ...transfer, progress: 100, failed: true }
                    : transfer
                )
              );
            }  
          });
      });
    },
    [currentDirectory, onUploadComplete, setDownloads]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: true,
  });

  return (
    <div {...getRootProps()} className="relative">
      <input {...getInputProps()} />
      {/* Base drop zone container, always rendered */}
      <div className="border border-dashed rounded p-6 text-center transition-colors">
        {isDragActive ? (
          <p className="text-lg font-bold text-blue-500">Drop the files here...</p>
        ) : (
          <p className="text-lg text-gray-600">
            Drag and drop files here
          </p>
        )}
      </div>

      {/* Full-screen overlay that only appears when files are dragged over */}
      {isDragActive && (
        <div className="fixed inset-0 bg-blue-100 bg-opacity-90 flex items-center justify-center pointer-events-none z-50">
          <p className="text-2xl font-bold text-blue-700">Release to upload</p>
        </div>
      )}
    </div>
  );
};

export default FileUploadZone;